import type { DraggableMetaType, FieldWrapper, ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { AreaItemType } from "../../../../../../../../../api/types/svTypes.ts";
import { extractMeta } from "../../../common/utilities/dropFieldContainerHelper.ts";
import { canDropItemBase } from "../canDropHelper.ts";

export const MaxRowsNumber = 5;

export const canDropRowItem = (
  item: FieldWrapper<ReportField> | DraggableMetaType,
  rows: ReportField[],
  columns: ReportField[]
): boolean => {
  const meta = extractMeta(item);
  if (!meta) {
    return false;
  }
  if (rows.length >= MaxRowsNumber) {
    return false;
  }

  if (item.type === AreaItemType.COLUMNS) {
    return !rows.some((f) => f.meta.name === meta.name);
  }

  return canDropItemBase(item, rows, columns);
};
